import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, emailReg, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import { globalActions, loginActions, useStore } from '@modules';

import Captcha from '@components/Captcha';
import Email from '@components/Email';
import LoginLayout from '@layouts/LoginLayout';

import style from './SetEmail.scss';

const cn = bemCssModules(style, 'SetEmail');
const ti = getTestId('SetEmail');

export const SetEmail: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ login, global }, dispatch] = useStore();
  const error = login.errors.data?.email?.[0];
  const isLoading = !!login.loaders.setEmail;

  const [email, setEmail] = useState('');
  const [isAgree, setAgree] = useState(false);
  const { isShowCaptcha, captcha } = global;

  useEffect(() => {
    return () => {
      dispatch(loginActions.clearErrors());
    };
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isShowCaptcha) dispatch(globalActions.setShowCaptcha(false));

    dispatch(loginActions.setEmail({ email, send_marketing_material: isAgree, captcha }))
      .unwrap()
      .then(res => {
        const next = res.data?.next;
        if (next) navigate<'login'>(`../${next}`, { state: { isSetEmail: true } });
      });
  };

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (error) dispatch(loginActions.clearErrors());
    setEmail(e.target.value);
  };

  const handleChangeAgree = () => {
    setAgree(!isAgree);
  };
  const isDisabled = !emailReg.test(email) || isLoading;

  const onBack = () => navigate(CONST.nav.login);

  return (
    <LoginLayout className={cn(null, [className])} data-testid={ti()} backButton={onBack}>
      <div className={cn('content')}>
        <h1 className={cn('title')}>{t('public.email')}</h1>
        <p className={cn('description')}>{t('public.email_description')}</p>
        <Email
          onSubmit={handleSubmit}
          onChangeEmail={handleChangeEmail}
          onChangeAgree={handleChangeAgree}
          email={email}
          error={error}
          isAgree={isAgree}
          isLoading={isLoading}
          isDisabled={isDisabled}
        />
        {isShowCaptcha && <Captcha className={cn('captcha')} />}
      </div>
    </LoginLayout>
  );
};

export default SetEmail;
